import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ce327d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row justify-content-center pt-5 gx-5",
  ref: "sectionMain",
  id: "section-1"
}
const _hoisted_2 = { class: "col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" }
const _hoisted_3 = { class: "col-lg-12 col-md-12 col-sm-12 d-lg-flex d-md-flex justify-content-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Resumo executivo", -1))
const _hoisted_5 = { class: "d-lg-flex d-md-flex justify-content-between legend" }
const _hoisted_6 = {
  class: "legend-circle",
  width: "14",
  height: "14"
}
const _hoisted_7 = ["fill"]
const _hoisted_8 = { class: "legend-text" }
const _hoisted_9 = { class: "row section-content d-lg-flex d-md-block justify-content-around" }
const _hoisted_10 = { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 d-flex flex-column first" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 d-flex flex-column second" }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 d-flex flex-column third" }
const _hoisted_15 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_responsive_table = _resolveComponent("responsive-table")!
  const _component_mini_map = _resolveComponent("mini-map")!
  const _component_GraphicTableCard = _resolveComponent("GraphicTableCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legendItems, (legendItem, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "legend-item"
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_6, [
                _createElementVNode("circle", {
                  fill: legendItem.color,
                  cx: "7",
                  cy: "7",
                  r: "7"
                }, null, 8, _hoisted_7)
              ])),
              _createElementVNode("span", _hoisted_8, _toDisplayString(legendItem.label), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("img", {
          class: "lcts-section-map",
          src: _ctx.completeOpportunity.thumb_completa,
          alt: "map"
        }, null, 8, _hoisted_11),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablesColumn1Area1, (table, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_component_responsive_table, {
              tableTitle: table.title,
              tableHeaders: table.headers,
              tableData: table.data,
              heatMapColors: table.info,
              pointColor: table.circleColor,
              showHeatMap: true
            }, null, 8, ["tableTitle", "tableHeaders", "tableData", "heatMapColors", "pointColor"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablesColumn2Area1, (table, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex flex-column second-sub",
            key: index
          }, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_responsive_table, {
                tableTitle: table.title,
                tableHeaders: table.headers,
                tableData: table.data,
                heatMapColors: table.info,
                pointColor: table.circleColor,
                showHeatMap: true
              }, null, 8, ["tableTitle", "tableHeaders", "tableData", "heatMapColors", "pointColor"]),
              _createVNode(_component_mini_map, {
                class: "d-none d-md-flex d-lg-flex",
                marketFilter: table.title === 'Média de Lançamentos no Raio' ? 'LANCAMENTO' : 'RAIO'
              }, null, 8, ["marketFilter"])
            ])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablesColumn2Area2, (table, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(_component_responsive_table, {
              tableTitle: table.title,
              tableHeaders: table.headers,
              tableData: table.data,
              heatMapColors: table.info,
              pointColor: table.circleColor,
              showHeatMap: true,
              tableMaxHeight: index === _ctx.tablesColumn2Area2.length - 1 ? '130px' : '185px'
            }, null, 8, ["tableTitle", "tableHeaders", "tableData", "heatMapColors", "pointColor", "tableMaxHeight"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_GraphicTableCard, {
          values: _ctx.valuesGraphic1,
          "bar-color": "#4F3C88",
          barColorBackground: "#BCA9F5",
          "circle-color": "#4FE48B",
          titleTable: "Classes sociais predominantes",
          "description-highlighted-table": "Classes Sociais:",
          "description-table": " Em relação a composição sociodemográfica municipal, a região do imóvel possui maior peso de Classe Social para: "
        }, null, 8, ["values"]),
        _createVNode(_component_GraphicTableCard, {
          values: _ctx.valuesGraphic2,
          "bar-color": "#319F55",
          barColorBackground: "#85FFB5",
          "circle-color": "#4FE48B",
          titleTable: "Grupos etários predominantes",
          "description-highlighted-table": "Grupos Etários: ",
          "description-table": " Em relação a composição demográfica municipal, a região do imóvel possui maior peso de Grupos Etários para: "
        }, null, 8, ["values"]),
        _createVNode(_component_GraphicTableCard, {
          values: _ctx.valuesGraphic3,
          "bar-color": "#006370",
          barColorBackground: "#49DEF2",
          "circle-color": "#4FE48B",
          titleTable: "Status conjugal predominante",
          "description-highlighted-table": "Status Conjugal: ",
          "description-table": " Em relação a composição conjugal municipal, a região do imóvel possui maior peso de conjugal para: ",
          "margin-top-footer": "50px",
          "height-table": "265px"
        }, null, 8, ["values"])
      ])
    ]),
    (_ctx.showHr)
      ? (_openBlock(), _createElementBlock("hr", _hoisted_15))
      : _createCommentVNode("", true)
  ], 512))
}